import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlowMeterReportToolbarComponent } from './flow-meter-report-toolbar.component';
import {
    DxButtonModule,
    DxDateBoxModule,
    DxLoadPanelModule,
    DxSelectBoxModule,
    DxToolbarModule,
    DxValidationGroupModule,
    DxValidatorModule
} from 'devextreme-angular';



@NgModule({
  declarations: [FlowMeterReportToolbarComponent],
    imports: [
        CommonModule,
        DxValidationGroupModule,
        DxToolbarModule,
        DxSelectBoxModule,
        DxDateBoxModule,
        DxLoadPanelModule,
        DxValidatorModule,
        DxButtonModule
    ],
  exports: [FlowMeterReportToolbarComponent]
})
export class FlowMeterReportToolbarModule { }
